<template>
    <div class="list">
        <!-- <NavBar></NavBar> -->
        <div class="nav">
            <van-nav-bar title="个人中心" right-text="充值历史" left-text="返回" left-arrow @click-left="onClickLeft" @click-right="onClickRight"/>
        </div>
        <div class="title_top">
            <van-row gutter="10" class="title_son">
                <van-col span="24">
                    <van-image round :src="headImgUrl" />
                </van-col>
                <van-col span='24' class="userName" style="">{{nickName}}</van-col>
            </van-row>
        </div>
        <!--  -->
        <!-- <van-col span="24" style="padding-top:10px;text-align:center">
            <van-image round width="6rem" height="6rem" :src="headImgUrl" />
        </van-col>
        <van-col span='24' style="margin-top:5px;text-align:center;font-weight:bold;margin-bottom:10px">个人中心</van-col> -->
        <div class="center-content">
            <van-col span='24' style="font-size:16px;font-weight:bold;padding:10px 0 10px 15px">我的房屋</van-col>
            <!-- <van-address-list v-model="chosenAddressId" :list="list" :switchable='false' /> -->
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" :finished="finished" @load="onLoad">
                    <div v-for="item in list" :key="item" style="padding:10px 5px 0 5px" class="squareStyle" @click="openDetail(item)">
                        <van-swipe-cell>
                            <van-col span='24' style="background-color:rgb(246 244 244);padding:10px 0;border-radius:7px">
                                <div class="sizeStyle">
                                    <van-col span='4' style="text-align:center;">
                                        <i class="iconfont icon-fangzi"></i>
                                    </van-col>
                                    <van-col span='17'>
                                        <!-- <van-col span='24' style="font-size:15px;padding:6px 7px 3px 7px">张三<span style="padding-left:3px;font-size:13px">15566668888</span></van-col> -->
                                        <van-col span='24' style="font-size:13px;padding:6px 7px">
                                            {{item.housename}}
                                        </van-col>
                                    </van-col>
                                    <van-col span='3' style="text-align:center">
                                        <van-icon name="arrow" />
                                    </van-col>
                                </div>
                            </van-col>
                            <template #right>
                                <van-button class="delete-button" square type="danger" text="解绑" @click="delet(item)"/>
                            </template>
                        </van-swipe-cell>
                    </div>
                </van-list>
            </van-pull-refresh>
            <!-- <div v-if="isShow2" style="margin-top:15px;font-size:14px;text-align:center;color:#e0e0e0">暂无数据</div> -->
            <van-empty v-if="isShow2" image="error" description="暂无数据" />
        </div>
        <van-col span='24' style="padding:40px 0"></van-col>
        <van-col span="24" style="padding:0px 10px 10px 10px;position: fixed;bottom:0;left:0;right:0;background-color:#fff">
            <van-button type="primary" size="normal" block @click="AddHouse">新增房屋</van-button>
            <!-- AddNewAddress -->
        </van-col>
        
    </div>
</template>

<script>
 import VueCookie from 'vue-cookie'
    export default {
        data() {
            return {
                nickName:'',
                isShow2:false,
                finished:false,
                error:false,
                loading:false,
                refreshing:false,
                openId:'',
                headImgUrl:'',
                // headImgUrl:VueCookie.get('headImgUrl'),
                // headImgUrl = VueCookie.get('headImgUrl')
                chosenAddressId:'',
                list:[],
                // list:[
                //     {
                //         id: '1',
                //         name: '张三',
                //         sss: '13000000000',
                //         address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室',
                //         // isDefault: true,
                //     },
                //     {
                //         id: '2',
                //         name: '张三',
                //         tel: '13000000000',
                //         address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室',
                //         // isDefault: true,
                //     },
                // ]
            }
        },
        methods: {
            onClickLeft() {
                history.go(-1);
            },
            onClickRight(){
                this.$router.push({
                    path:'/HistoricalRecharge'
                })
                // this.$router.push({
                //     path:'/HistoricalBills',
                //     query:{
                //         houseguid:this.houseguid
                //     }
                // })
            },
            openDetail(item){
                this.$router.push({
                    path:'/RechargeList',
                    query:{
                        houseguid:item.houseguid,
                        housename:item.housename,
                        balance:item.balance
                    }
                })
            },
            // 新增房屋
            AddHouse(){
                this.$router.push({
                    path:'/AddNewAddress',
                })
            },
            onLoad(){
                let data={
                    openid:this.openId
                }
                this.$postQuery('/HouseInfo/getBindHouseListByOpenId', data).then((response) => {
                    console.log(response)
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }
                    if(response.code==200){
                        this.list = response.data
                        if(this.list.length==0){
                            this.isShow2 = true
                        }
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.list.length >= response.data.length) {
                            this.finished = true;
                        }
                    }
                })
            },
            // 列表接口
            getList(){
                let data={
                    openid:this.openId
                }
                this.$postQuery('/HouseInfo/getBindHouseListByOpenId', data).then((response) => {
                    console.log(response)
                })
            },
            delet(item){
                // console.log(item)
                this.$dialog.confirm({
                    message: '确定解绑'+item.housename+'吗？',
                }).then(() => {
                    // instance.close();
                    // console.log(item)
                    let data={
                        houseguid:item.houseguid,
                        openid:this.openId
                    }
                    this.$postQuery('/HouseInfo/unbind',data).then((response)=>{
                        // console.log(response)
                        if(response.code==200){
                            this.$toast('操作成功！')
                            this.onLoad()
                        }else{
                            this.$toast('操作失败！')
                        }
                    })
                }).catch(()=>{});
            },
            onAdd() {

            },
            beforeClose({ position }){
                switch (position) {
                    case 'right':
                        this.$dialog.confirm({
                            message: '确定删除吗？',
                        }).then(() => {
                            // instance.close();
                            // console.log(item)
                        });
                        break;
                }
            },
            onRefresh(){
                // 清空列表数据
                this.finished = false;
                //重新加载数据
                this.loading = true;
                this.onLoad();
            },
        },
        created() {
           this.openId = VueCookie.get('openId')
        // this.openId = 'oXdaiwXCAyoHMVHhWW3WLJB5Xicw'
        //    this.getList()
        this.headImgUrl = VueCookie.get('headImgUrl')
        this.nickName = VueCookie.get('nickName')
        }
    }
</script>

<style scoped>
    .squareStyle>>>.van-swipe-cell__right{
        border-left: 1px solid #e0e0e0;
        border-radius: 0 5px 5px 0;
        overflow: hidden;
    }
    .list {
        margin-top: 46px;
    }
    .sizeStyle{
        display: flex;
        align-items: center;
    }
    .deposit_button{
        height: 100%;
    }
    .squareStyle>>>.van-button{
        height: 100% !important;
    }
    .title_top{
        padding:7px;
    }
    .title_son{
        background-image: url('../../assets/Image/banner-center.png');
        background-repeat:no-repeat;
        background-position:center;
        background-size: auto 100%;
        border-radius: 10px;
        text-align:center;
        padding:70px 0 50px 0;
    }
    .title_son .van-image{
        width: 65px;
        height: 65px;
        display: block;
        margin: 0 auto;
    }
    .center-content{
        margin: -60px 10px 0 10px;
        z-index: 99;
        border-radius: 20px 20px 0 0;
        background-color: #fff;
    }
    .iconfont{
        font-size: 22px;
        color:#2a5caa;
    }
    .userName{
        text-align:center;
        font-weight:bold;
        color:#333;
        line-height:35px;
        margin-bottom:20px;
        width:100%;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
        padding: 0 20px;
    }
</style>